import {connect} from 'react-redux';

import {CardGroupModel} from '../../../../../../../../src/models/api/cardGroupModel';
import {
  createContactFormCardGroupAddedAction,
  createContactFormCardGroupRemovedAction,
} from '../../../../../../../../src/store/panels/contacts/createContactForm/createContactFormActions';
import {ContactsManagerPanelId} from '../../../../../../../../src/store/panels/panelStateBase';
import {makeMapDispatchToProps} from '../../../../../../../../srcCommon/helpers/reselectHelpers';
import {CreateContactCardGroupInput} from './createContactCardGroupInput';

/*
 * Props.
 */

interface CreateContactCardGroupInputContainerProps {
  panelId: ContactsManagerPanelId;
}

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps<CreateContactCardGroupInputContainerProps>()(
  ({panelId}) => ({
    onSelect: (cardGroup: CardGroupModel) => createContactFormCardGroupAddedAction(panelId, cardGroup),
    onRemove: (cardGroup: CardGroupModel) => createContactFormCardGroupRemovedAction(panelId, cardGroup),
  }),
);

export const CreateContactCardGroupInputContainer = connect(
  null,
  mapDispatchToProps,
)(CreateContactCardGroupInput);
